import { SERVER_URL } from "../../api";
import axios from 'axios'
import { getHeaderWithToken } from "../../helpers/func";
export const DELETE_SIZE_REQUEST = 'DELETE_SIZE_REQUEST';
export const DELETE_SIZE_SUCCESS = 'DELETE_SIZE_SUCCESS';
export const DELETE_SIZE_ERROR = 'DELETE_SIZE_ERROR';
export const RESET_DELETE_SIZE = 'RESET_DELETE_SIZE';


export const deleteSize = (data) => {
    let headers = getHeaderWithToken();
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: DELETE_SIZE_REQUEST
            })
            axios({
                method: 'DELETE',
                url: `${SERVER_URL}v1/pattern/size/${data}`,
                headers: headers
            }).then(function (response) {
                dispatch({
                    type: DELETE_SIZE_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: DELETE_SIZE_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}



